import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';
import {
  Button,
  Modal,
} from 'react-bootstrap';

import { Coa, Table } from 'services/action';
import { Form, Select } from 'ui/components';

import _ from 'underscore';

const posSaldo = [
  { value: 'credit', label: 'Credit' },
  { value: 'debit', label: 'Debit' },
];

const posReport = [
  { value: 'N', label: 'N' },
  { value: 'L/R', label: 'L/R' },
];

const initialState = {
  code: '',
  name: '',
  selectedPosSaldo: null,
  selectedPosReport: null,
};

export const FormGeneral = ({
  data,
  onClose,
}) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state?.Form);
  const StateTable = useSelector((state) => state?.Table?.data['coa']);

  const [
    {
      code,
      name,
      selectedPosSaldo,
      selectedPosReport,
    },
    setState,
  ] = React.useState(initialState);

  const $handleSubmit = async (c) => {
    const payload = {
      code,
      name,
      pos_saldo: selectedPosSaldo?.value,
      pos_report: selectedPosReport?.value,
    };

    if (data) {
      const submit = await Dispatch(Coa.$update(data?.id, payload));
      if (submit?.message === 'success') {
        onClose();
        Dispatch(Table.$reload('coa', StateTable));
      }
    } else {
      const submit = await Dispatch(Coa.$create(payload));
      if (submit?.message === 'success') {
        onClose();
        Dispatch(Table.$reload('coa', StateTable));
      }
    };
  }

  React.useEffect(() => {
    if (!data) return

    let ops = null
    let opr = null
    _.each(posSaldo, (i) => {
      if (i?.value === data?.pos_saldo) {
        ops = i
      }
    })

    _.each(posReport, (i) => {
      if (i?.value === data?.pos_report) {
        opr = i
      }
    })

    setState((prevState) => ({
      ...prevState,
      selectedPosSaldo: ops,
      selectedPosReport: opr,
      code: data?.code,
      name: data?.name,
    }));
  }, [data]);

  return (
    <>
      <Modal.Body>
        <Form.Input
          required
          label="Code"
          type="text"
          value={code}
          onChange={(e) =>
            setState((prevState) => ({...prevState, code: e.target.value}))
          }
          error={StateForm?.errors?.code}
        />
        <Form.Input
          required
          label="Name"
          type="text"
          value={name}
          onChange={(e) =>
            setState((prevState) => ({...prevState, name: e.target.value}))
          }
          error={StateForm?.errors?.name}
        />
        <div className="mb-3">
          <label className='form-label required'>Pos Saldo</label>
            <Select
              isClearable
              classNamePrefix={
                StateForm?.errors?.pos_saldo ? 'is-invalid' : 'select'
              }
              placeholder=""
              value={selectedPosSaldo}
              options={posSaldo}
              onChange={(e) =>
                setState((prevState) => ({...prevState, selectedPosSaldo: e}))
              }
              error={StateForm?.errors?.pos_saldo}
            />
            {StateForm?.errors?.pos_saldo ? (
              <div className="invalid-feedback" style={{ display: 'block' }}>
                {StateForm?.errors?.pos_saldo}
              </div>
            ) : null}
        </div>
        <div className="mb-3">
          <label className='form-label required'>Pos Report</label>
            <Select
              isClearable
              classNamePrefix={
                StateForm?.errors?.pos_report ? 'is-invalid' : 'select'
              }
              placeholder=""
              value={selectedPosReport}
              options={posReport}
              onChange={(e) =>
                setState((prevState) => ({...prevState, selectedPosReport: e}))
              }
              error={StateForm?.errors?.pos_report}
            />
            {StateForm?.errors?.pos_report ? (
              <div className="invalid-feedback" style={{ display: 'block' }}>
                {StateForm?.errors?.pos_report}
              </div>
            ) : null}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className='row w-100'>
          <div className='col'>
            <Button
              type="button"
              className='btn btn-light w-100'
              onClick={() => onClose()}
            >
              Batal
            </Button>
          </div>
          <div className='col'>
            <Button
              type="button"
              className={cn(
                StateForm?.loading ? 'btn-loading' : '', 'btn btn-primary w-100'
              )}
              disabled={StateForm?.loading}
              onClick={$handleSubmit}
            >
              Simpan
            </Button>
          </div>
        </div>
      </Modal.Footer>
    </>
  );
};
